
import styled from 'styled-components';
import Link from '@/components/molecules/Link';
import { Svg } from '@/components/styled';
import { ICONS, List as IconsList } from '@/public/img/icons';
import devices from '@/utilities/devices';
import { renderIcons } from '@/utilities/functions';

// #region SectorCardComponent
interface SectorCardOwnProps {
	/**
	 * Link to the sector page.
	 */
	href: string;
	/**
	 * Icon identifier to display in the card.
	 */
	icon: ICONS;
	/**
	 * An array of jobs available for a sector.
	 */
	listOfJobs: string[];
	/**
	 * Title of the card.
	 */
	title: string,
}

// #region STYLE
const SectorCardContainer = styled(Link)`
	display: block;
	background-color: ${({ theme }) => theme.color.white};
	border: 1px solid ${({ theme }) => theme.color.grey};
	border-radius: 4px;
	box-shadow: 0px -1px 20px -3px rgba(0,0,0, .01);
	margin: 1rem;
	text-decoration: none;
	transition: .2s;
	width: 15rem;

	.sectordCard-title {
		align-items: center;
		border-bottom: 1px solid ${({ theme }) => theme.color.grey};
		color: ${({ theme }) => theme.color.prune};
		display: flex;
		font-weight: bold;
		padding: .2rem 1.375rem;

		.text {
			font-size: ${({ theme }) => theme.fontSize.SMALL};
			padding-left: 1rem;
		}
		svg {
			height: 32px;
			padding: .7em 0 .1em;
			width: 32px;
		}
	}

	.sectorCard-list {
		color: ${({ theme }) => theme.color.greyDarker};
		font-size: ${({ theme }) => theme.fontSize.XSMALL};
		padding: 1.2rem 1.375rem;

		div {
			padding: .4em 0;
		}
	}

	:hover {
		box-shadow: 0px -1px 20px 4px rgba(0,0,0, .05);
		transform: translateY(-3px);
	}

	@media screen and (${devices.mobile}) {
		width: 100%;
		margin: 1.4rem 0rem;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		width: 16rem;
	}
`;
// #endregion

const SectorCard = ({ href, title, icon, listOfJobs }: SectorCardOwnProps) => {
	return (
		<SectorCardContainer href={href} openOnNewTab={false}>
			<div className='sectordCard-title'>
				<Svg color='prune'>
					{renderIcons(icon, IconsList)}
				</Svg>
				<div className='text'>{title}</div>
			</div>
			<div className='sectorCard-list'>
				{listOfJobs.map((job, key) => (
					<div key={key}>{job}</div>
				))}
			</div>
		</SectorCardContainer>
	);
};
// #endregion

export default SectorCard;
